import { Card, CardMedia, Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { format } from 'date-fns';
import React from 'react';
import ImgLogo from '../../assets/images/tst-saude.png';
import { withUsuario } from '../../contexts/UsuarioContext';

const styles = theme => ({
  card: {
    maxWidth: 100,
    maxHeight: 100,
    display: 'inline-block'
  },
  media: {
    objectFit: 'cover',
    maxWidth: 80,
    maxHeight: 80,
  },
  paperHeader: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2),
    heigth: theme.spacing(5)
  },
  paperFontPrimary: {
    textAlign: 'center',
    fontSize: 14,
    color: 'black',
    marginTop: theme.spacing(1.5),
  },
  paperFontSecondary: {
    textAlign: 'center',
    fontSize: 12,
    color: 'grey',
    marginTop: theme.spacing(1.5),
  },
  divTitulo: {
    margin: 'auto',
    marginTop: theme.spacing(1.5),
    width: '90%',
    border: `0px solid ${theme.palette.primary.main}`,
    padding: '20px',
    display: 'inline-block',
  },
  divImagem: {
    display: 'inline-block',
    marginTop: theme.spacing(1.5),
  },
});

class ReportHeader extends React.Component {
  render () {
    const { classes, titulo } = this.props;
    return (
      <Paper className={classes.paperHeader}>
        <div className={classes.divImagem}>
          <Card className={classes.card}>
              <CardMedia
                component='img'
                className={classes.media}
                image={ImgLogo}
              />
            </Card>
        </div>
        <div className={classes.divTitulo}>
          <Typography className={classes.paperFontPrimary}>{titulo}</Typography>
          {this.props.nomeUsuario !== undefined
            ? <Typography className={classes.paperFontSecondary}>{'emitido em ' + format(new Date(), 'DD/MM/YYYY') + ' por ' + this.props.nomeUsuario + ' às ' + format(new Date(), 'HH:mm:ss')}</Typography>
            : <Typography className={classes.paperFontSecondary}>{'emitido em ' + format(new Date(), 'DD/MM/YYYY') + ' às ' + format(new Date(), 'HH:mm:ss')}</Typography>}
        </div>
      </Paper>
    );
  }
}
export default withUsuario(withStyles(styles)(ReportHeader));
